import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./almoxarifado.component.html')
})
export class AlmoxarifadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/almoxarifado.component.ts
 **/